import React from "react";
import Preloader from "../../helper/Preloader";
import HeaderOne from "../../components/layout/HeaderOne";
import Breadcrumb from "../../components/Breadcrumb";
import SearchProduct from "../../components/product/SearchProduct";
import FooterOne from "../../components/layout/FooterOne";
import ColorInit from "../../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import BottomFooter from "../../components/layout/BottomFooter";

const SearchProductPage = ({ isWholesale = false }) => {

  return (
    <>
      {/* ColorInit */}
      <ColorInit color={false} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#990A02" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderOne */}
      <HeaderOne isWholesale={isWholesale} />

      {/* Breadcrumb */}
      <Breadcrumb title={isWholesale ? "Wholesale Search Products" : "Search Products"} />

      {/* SearchProduct */}
      <SearchProduct isWholesale={isWholesale} />

      {/* ShippingTwo */}
      {/* <ShippingTwo /> */}

      {/* FooterTwo */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />

    </>
  );
};

export default SearchProductPage;
